module.exports = __webpack_public_path__ + "static/media/search_time.1b4142d3.svg";